var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 81,
    viewBox: "0 0 95 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 68.3492C14.2289 61.321 21.3432 53.063 21.3432 43.5748C15.2784 42.872 10.2634 40.3829 6.29799 36.1074C2.33257 31.8319 0.349892 26.8829 0.349892 21.2603C0.349892 15.2863 2.27425 10.2495 6.12305 6.14967C9.97184 2.04987 14.8119 0 20.6434 0C27.1747 0 32.8312 2.66483 37.613 7.99458C42.3948 13.3243 44.7857 19.7961 44.7857 27.41C44.7857 50.2517 32.0732 68.1149 6.64788 81L0 68.3492ZM50.2143 68.3492C64.5598 61.321 71.7324 53.063 71.7324 43.5748C65.551 42.872 60.4777 40.3829 56.5123 36.1074C52.5469 31.8319 50.5642 26.8829 50.5642 21.2603C50.5642 15.2863 52.5177 10.2495 56.4248 6.14967C60.3319 2.04987 65.2011 0 71.0326 0C77.5639 0 83.1912 2.66483 87.9148 7.99458C92.6383 13.3243 95 19.7961 95 27.41C95 50.2517 82.3458 68.1149 57.0371 81L50.2143 68.3492Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.c98a813b2747d706b8e632c460f880c7.svg";
export { ForwardRef as ReactComponent };